import React, { useContext, useState, useEffect, useRef } from 'react'
import { Input, Form, Select, DatePicker, InputNumber } from 'antd'
import { FormInstance, Rule } from 'antd/lib/form'
import { ISelectOption } from '../YhFormBox/Types'
import moment from 'moment'
// 请保证最先引入 cnchar 基础库，其他几个库顺序无所谓
import cnchar from 'cnchar'
import 'cnchar-poly'
// ... 其他插件请参考第二章 2. 功能及插件概览
// 插件请按需取用
const { RangePicker } = DatePicker

const EditableContext = React.createContext<FormInstance<any> | null>(null)

//tr 行信息
export interface Item {
    [key: string]: string | number | boolean | undefined | object
}

//表单类型
type IEditType = 'input' | 'select' | 'datepicker' | 'treeSelect' | 'number' | 'nowdatepicker' | 'longDatepicker'
interface EditableRowProps {
    index: number
}
enum IKeysCode {
    up = 38,
    down = 40,
    // tab = 9,
    left = 37,
    right = 39,
}

export const EditableRow: React.FC<EditableRowProps> = ({ index, ...props }) => {
    const [form] = Form.useForm()
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    )
}

interface EditableCellProps {
    colIndex: number
    rowIndex: number
    editType?: IEditType
    rules?: Rule[]
    title: React.ReactNode
    options?: ISelectOption[]
    mode?: 'multiple' | 'tags' | undefined
    editable: boolean
    children: React.ReactNode
    dataIndex: keyof Item
    record: Item
    handleSave: (record: Item) => void
    onSelectChange?: (value: string, options: ISelectOption, record: Item) => void
    onSelectFocus?: (record: Item) => void
    onSelectSearch?: (value: string, record: Item) => void
    onInputEnter?: (value: EventTarget, record: Item) => void
}

export const EditableCell: React.FC<EditableCellProps> = ({
    colIndex, //第几列下标
    rowIndex, //第几行下标
    editType = 'input',
    options,
    rules,
    title,
    mode,
    editable,
    children,
    dataIndex,
    record,
    onSelectChange,
    onSelectFocus,
    onSelectSearch,
    handleSave,
    onInputEnter,
    ...restProps
}) => {
    const [editing, setEditing] = useState(false)
    const inputRef = useRef<any>(null)
    const form = useContext(EditableContext)!

    useEffect(() => {
        if (editing && editType === 'input') {
            inputRef.current?.focus()
            inputRef.current?.select()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editing])

    const toggleEdit = () => {
        setEditing(!editing)
        form.setFieldsValue({ [dataIndex]: record[dataIndex] })
    }

    const save = async () => {
        try {
            const values = await form.validateFields()
            toggleEdit()
            handleSave({ ...record, ...values, changeFields: dataIndex })
        } catch (errInfo) {
            console.log('Save failed:', errInfo)
        }
    }

    //监听键盘事件
    const onKeyUp = (e: any) => {
        let rowNum = rowIndex + 1 //当前行数
        let keyCode = e.keyCode //键码
        let tbodyChildren = e.target?.closest('tbody').children //当前所有的tr 行let
        let isTotalText: boolean = tbodyChildren[tbodyChildren.length - 1].textContent?.indexOf('合计') > -1 //是否包含合计最后一行
        let trLength = tbodyChildren.length - (isTotalText ? 2 : 1) //减去表头哪一行，所有tr数量

        //上键
        if (keyCode === IKeysCode.up) {
            e.preventDefault()
            e.returnValue = true
            let isPrev = rowNum <= 1
            // if (isPrev) {
            //     message.success("没有上一行");
            //     return;
            // }
            tbodyChildren[isPrev ? trLength : rowNum - 1].children[colIndex]?.children[0]?.click()

            //下键
        } else if (keyCode === IKeysCode.down) {
            e.preventDefault()
            let isNext = rowNum < trLength
            // if (!isNext) {
            //     message.success("没有下一行");
            //     return;
            // }
            tbodyChildren[isNext ? rowNum + 1 : 1]?.children[colIndex]?.children[0]?.click()

            //右键
        } else if (keyCode === IKeysCode.right) {
            e.preventDefault()
            let tdAll = tbodyChildren[rowNum]?.children //当前行所有列数；
            let numArr: number[] = [] //记录input输入框所有td的下标
            for (let i = 0; i < tdAll.length; i++) {
                tdAll[i].getAttribute('data-type') === 'yh-input' && numArr.push(i)
            }
            if (!numArr.length || numArr.length === 1) {
                return
            }

            let findIndex = numArr.findIndex((item) => item === colIndex) //查找处于第几个
            if (findIndex === numArr.length - 1) {
                //最后一个，直接到第一个。否则下一个
                tdAll[numArr[0]]?.children[0].click()
            } else {
                tdAll[numArr[findIndex + 1]]?.children[0]?.click()
            }

            //左键
        } else if (keyCode === IKeysCode.left) {
            e.preventDefault()
            let tdAll = tbodyChildren[rowNum]?.children //当前行所有列数；
            let numArr: number[] = [] //记录input输入框所有td的下标
            for (let i = 0; i < tdAll.length; i++) {
                tdAll[i].getAttribute('data-type') === 'yh-input' && numArr.push(i)
            }
            if (!numArr.length || numArr.length === 1) {
                return
            }

            let findIndex = numArr.findIndex((item) => item === colIndex) //查找处于第几个
            if (findIndex === 0) {
                //第一个，直接到最后一个。否则上一个
                tdAll[numArr[numArr.length - 1]]?.children[0]?.click()
            } else {
                tdAll[numArr[findIndex - 1]]?.children[0]?.click()
            }
        }
        // //tab切换
        // else if (keyCode === IKeysCode.tab) {
        //     debugger;
        //     e.preventDefault();
        //     let tdAll = tbodyChildren[rowNum]?.children;  //当前行所有列数；
        //     let numArr: number[] = [];        //记录input输入框所有td的下标
        //     for (let i = 0; i < tdAll.length ?? 0; i++) {
        //         tdAll[i].getAttribute("data-type") === "yh-input" && numArr.push(i);
        //     }
        //     let findIndex = numArr.findIndex(item => item === colIndex); //查找处于第几个

        //     if (!numArr.length) { return }
        //     if (findIndex === numArr.length - 1) {  //最后一个，直接到第一个。否则下一个
        //         tdAll[numArr[0]]?.children[0].click();
        //     } else {
        //         tdAll[numArr[findIndex + 1]]?.children[0].click();
        //     }
        // }
    }
    let childNode = children
    const today = moment().format('YYYY-MM-DD 00:00:00')
    const tomorrow = moment().add(1, 'days').format('YYYY-MM-DD  23:59:59')
    const selectPinYin = (input, option) => {
        //如果以拼音首字母输入搜索
        if (input.charCodeAt() >= 32 && input.charCodeAt() <= 126) {
            return cnchar.spell(option.label.toLowerCase()).includes(input.toLowerCase())
            //如果以中文输入搜索
        } else {
            return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
    }

    const disabledDate = (current) => {
        // 禁用今天之前（不包括今天）的所有日期
        return current.isBefore(today) || current.isAfter(tomorrow)
    }
    const disabledLongDate = (current) => {
        // 禁用今天之前（不包括今天）的所有日期
        return current.isBefore(today)
    }
    const inputTypes = () => {
        switch (editType) {
            case 'input':
                return (
                    <Input
                        ref={inputRef}
                        onPressEnter={
                            onInputEnter
                                ? (e) => {
                                      onInputEnter(e.target, record)
                                  }
                                : undefined
                        }
                        onBlur={save}
                        onKeyUp={onKeyUp}
                    />
                )
            case 'select':
                return (
                    <Select
                        defaultOpen
                        autoFocus
                        ref={inputRef}
                        showSearch={true}
                        optionFilterProp="label"
                        filterOption={(input, option) => selectPinYin(input, option)}
                        onBlur={save}
                        allowClear={true}
                        onSelect={(value: string, option) => {
                            onSelectChange?.(value, option as ISelectOption, record)
                        }}
                        onSearch={(value) => onSelectSearch?.(value, record)}
                        options={options ?? []}
                        mode={mode}
                    />
                )
            case 'datepicker':
                return <DatePicker format="YYYY-MM-DD" showTime={true} showNow={true} onBlur={save} allowClear={true} inputReadOnly />
            case 'nowdatepicker':
                return (
                    <DatePicker
                        autoFocus
                        inputReadOnly
                        // showTime={true}
                        format="YYYY-MM-DD HH:mm:ss" // 设置日期时间格式
                        disabledDate={disabledDate}
                        // disabledTime={disabledTime}
                        // showNow={true}
                        showTime={{
                            defaultValue: moment('06:00:00', 'HH:mm:ss'),
                        }}
                        onBlur={save}
                        allowClear={true}
                    />
                )
            case 'longDatepicker':
                return (
                    <RangePicker
                        autoFocus
                        inputReadOnly
                        // showTime={true}
                        format="YYYY-MM-DD HH:mm:ss" // 设置日期时间格式
                        disabledDate={disabledLongDate}
                        // disabledTime={disabledTime}
                        // showNow={true}
                        placeholder={['开始时间', '结束时间']}
                        showTime={{
                            defaultValue: [moment('06:00:00', 'HH:mm:ss'), moment('06:00:00', 'HH:mm:ss')],
                        }}
                        onBlur={save}
                        allowClear={true}
                    />
                )
            case 'number':
                return <InputNumber ref={inputRef} onBlur={save} />
            default:
                return <></>
        }
    }
    if (editable) {
        childNode = editing ? (
            <Form.Item style={{ margin: 0 }} name={dataIndex} rules={rules}>
                {inputTypes()}
            </Form.Item>
        ) : (
            <div className={`editable-cell-value-wrap`} onClick={toggleEdit}>
                {children}
            </div>
        )
    }

    return (
        <td {...restProps} data-type={`${editable ? `yh-${editType}` : ''}`}>
            {childNode}
        </td>
    )
}
